import { StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    // justifyContent: 'space-between',
    marginHorizontal: 16,
  },
  contentContainer: {
    alignItems: 'center',
    marginVertical: 30
  },
  title: theme => ({
    fontSize: 20,
    width: 250,
    textAlign: 'center',
    lineHeight: 25,
    marginTop: 25,
    ...Fonts.type.bold,
    marginBottom: 15,
  }),
  subtitle: theme => ({
    fontSize: 17,
    textAlign: 'center',
    marginTop: 35,
    lineHeight: 18,
  }),
  description: theme => ({
    fontSize: 18,
    marginTop: 20,
    textAlign: 'center',
    lineHeight: 18,
  }),
})
